exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-textarea .el-textarea__inner[data-v-629f6f79]{width:100%;overflow-y:hidden!important;resize:none}", ""]);

// exports
